import { AttachmentRule, Behavior } from "./types";

export class RandomScaleBehavior extends Behavior {
  private minScale: number = 0.5;
  private maxScale: number = 3.0;

  static getAttachmentRules(): AttachmentRule[] {
    return [{ type: "class", selector: "random-scale" }];
  }

  onAttach(): void {
    console.log("RandomScaleBehavior attached to:", this.element);

    // Read scale bounds from attributes if they exist
    const minScaleAttr = this.element.getAttribute("min-scale");
    const maxScaleAttr = this.element.getAttribute("max-scale");

    if (minScaleAttr) {
      this.minScale = parseFloat(minScaleAttr) || this.minScale;
    }

    if (maxScaleAttr) {
      this.maxScale = parseFloat(maxScaleAttr) || this.maxScale;
    }

    // Ensure min is not greater than max
    if (this.minScale > this.maxScale) {
      [this.minScale, this.maxScale] = [this.maxScale, this.minScale];
    }

    // Generate random scale for each axis independently
    const randomScaleX = this.minScale + Math.random() * (this.maxScale - this.minScale);
    const randomScaleY = this.minScale + Math.random() * (this.maxScale - this.minScale);
    const randomScaleZ = this.minScale + Math.random() * (this.maxScale - this.minScale);

    // Apply the scale to the element
    this.element.setAttribute("sx", randomScaleX.toString());
    this.element.setAttribute("sy", randomScaleY.toString());
    this.element.setAttribute("sz", randomScaleZ.toString());

    console.log(
      `RandomScaleBehavior: Applied scale (${randomScaleX.toFixed(3)}, ${randomScaleY.toFixed(3)}, ${randomScaleZ.toFixed(3)}) (range: ${this.minScale}-${this.maxScale})`,
    );
  }

  onDetach(): void {
    console.log("RandomScaleBehavior detached from:", this.element);
    // Optionally reset scale when detaching
    // this.element.removeAttribute('scale');
  }
}
